<template lang="pug">
  .component-backoffice-home
    home-controller
</template>

<script type="text/babel">
import HomeController from './controllers/Home.vue'
import store from '../../store'

import merge from 'deepmerge'
import moment from 'moment'
import RangePicker from '../../components/structure/RangePicker'


export default {
  name: 'BackofficeHome',
  components: {
    RangePicker,
    HomeController,
  },

  watch: {
    form: {
      handler(val) {
        this.loadData()
      },
      deep: true
    }
  },
  mounted() {
    store.dispatch('getConfiguration')
  },
  created() {
    const start = moment().startOf('month').format('Y-MM-DD')
    const end = moment().format('Y-MM-DD')
    this.form.start = start
    this.form.end = end
    this.form = {
      start,
      end,
      bracketing: 'D'
    }

    this.loadData()
  },
  methods: {
    setRange(range) {
      this.form.start = range.from
      this.form.end = range.to
    },
  },
  data() {
    return {
      form: {
        start: null,
        end: null,
        bracketing: null
      },
      formLoading: false,
      dis: null,
      res: null,
      reg: null,
      vei: null,
      veiByZ: null,
      loadingVeiByZ: false,
    }
  }
}
</script>
<style lang="sass">
.map-wrapper
  width: 100%
  height: 768px


</style>



// WEBPACK FOOTER //
// Home.vue?3d56b7cc